import {
  EAutoPayItemStatus,
  EAutoPaySettingStatus,
  EBatchStatus,
  EChainStatus,
  EClaimStatus,
  EClaimTaskStatus,
  ELetterStatus,
  EPaymentStatus, EPccUploadTaskStatus,
  EResidentStatus,
  EStatementStatuses,
  EUserPermissions,
  EUserStatus,
  URL_MAPPING
} from '@zunta/configurations'
import { EUserPermissionsCategory, ITimeZoneListItem, IUserPermissionItem } from '@/interfaces'
import { waitUntil } from '@/utils/helpers'
import * as moment from 'moment'

const { facility: facilityUrls, template: templateUrls } = URL_MAPPING

export const PHONE_MASK = '(###) ###-####'
export const ZIP_MASK = '#####'
export const DATE_MASK = '##/##/####'
export const STORAGE_URL = process.env.VUE_APP_STORAGE_URL
export const STATEMENTS_STORAGE_URL = process.env.VUE_APP_STATEMENTS_STORAGE_URL
export const APP_URL = process.env.VUE_APP_APP_URL
export const APP_SERVER_HOST = process.env.VUE_APP_SERVER_URL
export const STATEMENT_MESSAGE_TEMPLATE_VIEW_URL = `${APP_SERVER_HOST}/api/${templateUrls.prefix}${templateUrls.getFakeStatementMessageTemplatePdf.path}`
export const STATEMENT_MESSAGE_TEMPLATE_PDF_VIEW_URL = `${APP_SERVER_HOST}/api/templates/getPDFTemplateLetter`
export const TEMPLATE_VIEW_URL = `${APP_SERVER_HOST}/api/${templateUrls.prefix}${templateUrls.getTemplatePdf.path}`
export const FACILITY_HIPPA_AGREEMENT_TEMPLATE_URL = `${APP_SERVER_HOST}/api/${facilityUrls.prefix}${facilityUrls.hippaAgreementTemplate.path}`
export const FACILITY_ZUNTA_LICENSE_AGREEMENT_TEMPLATE_URL = `${APP_SERVER_HOST}/api/${facilityUrls.prefix}${facilityUrls.zuntaLicenseTemplate.path}`
export const SOCKET_PATH = process.env.VUE_APP_SOCKET_PATH
export const MIRROR_SOCKET_PATH = process.env.VUE_APP_MIRROR_SOCKET_PATH
export const V2_APP_BFF_URL = process.env.VUE_APP_V2_APP_BFF_URL
export const V2_MYMEDPORTAL_BFF_URL = process.env.VUE_APP_V2_MYMEDPORTAL_BFF_URL
export const EMAIL_REGEX = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i

export const ROUTING_NUMBER_IMAGE_MAP: any = {
  '226077862': 'federal-union.png',
  '263079043': 'financial-union.png',
  '257079033': 'tfr-federal-union.png',
  '275981909': 'community-union.png',
  '061107816': 'citizens-bank.png',
  '053201924': 'citizens-bank.png',
  '053207685': 'citizens-bank.png',
  '061111271': 'citizens-bank.png',
  '281082203': 'city-union.png'
}

export const TIMEZOMES_LIST: ITimeZoneListItem[] = [{
  name: 'Eastern Standard Time',
  shortName: 'EST',
  timezone: -5
},
  {
    name: 'Central Standard Time',
    shortName: 'CST',
    timezone: -6
  },
  {
    name: 'Mountain Standard Time',
    shortName: 'MST',
    timezone: -7
  },
  {
    name: 'Pacific Standard Time',
    shortName: 'PST',
    timezone: -8
  },
  {
    name: 'Hawaii Standard Time',
    shortName: 'HST',
    timezone: -10
  }, {
    name: 'Alaska Standard Time',
    shortName: 'AKST',
    timezone: -9
  }]

export const MODULE_ITEMS: any[] = [
  {
    key: 'Mailing',
    value: 'Mailing',
    content: 'Mailing'
  },
  {
    key: 'Aging',
    value: 'Aging',
    content: 'Aging'
  },
  {
    key: 'Payments',
    value: 'Payments',
    content: 'Payments'
  }
]

export const USER_PERMISSIONS_LIST: Array<IUserPermissionItem> = [{
  name: 'View',
  description: 'Information',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.VIEW_FACILITIES
}, {
  name: 'Add',
  description: 'To be managed by Zunta',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.ADD_FACILITY
}, {
  name: 'Deactivate',
  description: 'From being managed by Zunta',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.DEACTIVATE_FACILITY
}, {
  name: 'Edit',
  description: 'Information',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.EDIT_FACILITY_INFORMATION
}, {
  name: 'Edit',
  description: 'Default Statement Settings',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.EDIT_STATEMENT_SETTINGS
}, {
  name: 'Add/Edit',
  description: 'Payers',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.MODIFY_PAYER_TYPES
}, {
  name: 'View',
  description: 'Collections Flows',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.VIEW_COLLECTIONS_FLOW
}, {
  name: 'Add/Edit/Delete',
  description: 'Collections Flows',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.MODIFY_COLLECTIONS_FLOW
}, {
  name: 'View',
  description: 'Templates',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.VIEW_TEMPLATES
}, {
  name: 'Add/Edit/Delete',
  description: 'Templates',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.MODIFY_TEMPLATES
}, {
  name: 'View',
  description: 'Payment Accounts and Settings',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS
}, {
  name: 'Configure',
  description: 'Payment Accounts',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.CONFIGURE_PAYMENTS_ACCOUNTS
}, {
  name: 'Edit',
  description: 'Payment Settings',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.EDIT_PAYMENT_SETTINGS
}, {
  name: 'Add/Edit/Delete',
  description: 'Batch Templates',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.EDIT_FACILITY_ADVANCED_SETTINGS
}, {
  name: 'View',
  description: 'List of Residents',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.VIEW_RESIDENTS
}, {
  name: 'Edit',
  description: 'Settings for sending statements and excluding from collections',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.EDIT_RESIDENT_SETTINGS
}, {
  name: 'Edit',
  description: 'Mailing Contact & Collections Contact',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.EDIT_CONTACT_SETTINGS
}, {
  name: 'Add/Edit/Delete',
  description: 'Payment Methods',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.MODIFY_PAYMENT_METHOD
}, {
  name: 'Add Note',
  description: 'To Resident history',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.ADD_HISTORY_NOTE
}, {
  name: 'Make Payment',
  description: 'For a Resident',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.MAKE_PAYMENT
}, {
  name: 'Create',
  description: 'AutoPay Schedule',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.CREATE_AUTOPAY
}, {
  name: 'Refund',
  description: 'For a resident',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.REFUND_PAYMENT
}, {
  name: 'Delete',
  description: 'AutoPay Schedule',
  category: EUserPermissionsCategory.RESIDENT,
  permission: EUserPermissions.DELETE_AUTOPAY
}, {
  name: 'View Payments',
  description: 'View Payments Section',
  category: EUserPermissionsCategory.PAYMENTS,
  permission: EUserPermissions.VIEW_PAYMENTS
},
  // {
  //   name: 'View Payments Dashboard',
  //   description: 'View the Quick Stats on the Payments Page',
  //   category: EUserPermissionsCategory.PAYMENTS,
  //   permission: EUserPermissions.VIEW_PAYMENTS_DASHBOARD
  // },
  {
    name: 'View Autopayments',
    description: 'View Autopayments',
    category: EUserPermissionsCategory.PAYMENTS,
    permission: EUserPermissions.VIEW_AUTOPAY
  }, {
  name: 'Review Autopayments',
  description: 'Scheduled, Upcoming and Declined Payments',
  category: EUserPermissionsCategory.PAYMENTS,
  permission: EUserPermissions.REVIEW_PAYMENTS
}, {
  name: 'View',
  description: 'Deposits made into your Facility Accounts',
  category: EUserPermissionsCategory.PAYMENTS,
  permission: EUserPermissions.VIEW_DEPOSITS
}, {
  name: 'View',
  description: 'Mailings Page',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.VIEW_MAILINGS
}, {
  name: 'Create/Update',
  description: 'Manual Batch ',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.MODIFY_BATCH_MANUALLY
}, {
  name: 'Delete',
  description: 'Batch',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.DELETE_BATCH
},
{
  name: 'Update',
  description: 'Completed Batch',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.ALLOW_UPDATE_COMPLETED_BATCH
},
{
  name: 'Show',
  description: 'Only Batches assigned to this User',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.SHOW_ONLY_ASSIGNED_BATCHES
}, {
  name: 'Mail Out',
  description: 'Mail Out Statements',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.MAIL_STATEMENTS
}, {
  name: 'Review',
  description: 'Review Statements',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.REVIEW_STATEMENTS
}, {
  name: 'Update',
  description: 'Statement Status',
  category: EUserPermissionsCategory.MAILINGS,
  permission: EUserPermissions.UPDATE_STATEMENT
}, {
  name: 'View',
  description: 'Collections Page',
  category: EUserPermissionsCategory.COLLECTIONS,
  permission: EUserPermissions.VIEW_COLLECTIONS
}, {
  name: 'Review',
  description: 'Collections',
  category: EUserPermissionsCategory.COLLECTIONS,
  permission: EUserPermissions.REVIEW_COLLECTIONS
}, {
  name: 'Review',
  description: 'Claims',
  category: EUserPermissionsCategory.COLLECTIONS,
  permission: EUserPermissions.ACCESS_TO_CLAIMS
}, {
  name: 'Edit',
  description: 'Claims Settings',
  category: EUserPermissionsCategory.COLLECTIONS,
  permission: EUserPermissions.ACCESS_TO_CLAIMS_SETTINGS
}, {
  name: 'View',
  description: 'Users Page',
  category: EUserPermissionsCategory.USERS,
  permission: EUserPermissions.VIEW_USERS
}, {
  name: 'Add/Edit/Deactivate',
  description: 'Zunta Users',
  category: EUserPermissionsCategory.USERS,
  permission: EUserPermissions.MODIFY_USERS
}, {
  name: 'Add/Edit/Delete',
  description: 'Zunta Roles',
  category: EUserPermissionsCategory.PERMISSIONS,
  permission: EUserPermissions.MODIFY_ROLES
}, {
  name: 'View',
  description: 'Permission Settings',
  category: EUserPermissionsCategory.PERMISSIONS,
  permission: EUserPermissions.VIEW_PERMISSIONS
}, {
  name: 'Edit',
  description: 'Permissions related to Roles',
  category: EUserPermissionsCategory.PERMISSIONS,
  permission: EUserPermissions.EDIT_PERMISSIONS
}, {
  name: 'Add/Edit',
  description: 'HMO\'s',
  category: EUserPermissionsCategory.PAYMENTS,
  permission: EUserPermissions.MODIFY_HMO
}, {
  name: 'Process',
  description: 'HMO Payments',
  category: EUserPermissionsCategory.PAYMENTS,
  permission: EUserPermissions.PROCESS_HMO
}, {
  name: 'View',
  description: 'Fees',
  category: EUserPermissionsCategory.FACILITY,
  permission: EUserPermissions.VIEW_FACILITY_FEES,
}]

// eslint-disable-next-line
console.assert(Object.keys(EUserPermissions).length === USER_PERMISSIONS_LIST.length, 'something wrong with permissions list', 'userPermissionsList', USER_PERMISSIONS_LIST.length, 'real list', Object.keys(EUserPermissions).length)

export const STATEMENT_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EStatementStatuses.NEEDS_REVIEW]: 'Needs Review',
  [EStatementStatuses.NEEDS_FIX]: 'Needs Fix',
  [EStatementStatuses.READY_TO_MAIL]: 'Ready to Mail',
  [EStatementStatuses.READY_TO_EMAIL]: 'Ready to E-Mail',
  [EStatementStatuses.READY_TO_PRINT]: 'Ready to Print',
  [EStatementStatuses.DO_NOT_BILL]: 'Excluded for this month',
  [EStatementStatuses.IN_PROCESS]: 'In Process',
  [EStatementStatuses.IN_TRANSIT]: 'In Transit',
  [EStatementStatuses.IN_LOCALAREA]: 'In Local area',
  [EStatementStatuses.DELIVERED]: 'Delivered',
  [EStatementStatuses.RETURNED]: 'Mail Returned',
  [EStatementStatuses.REROUTED]: 'Rerouted',
  [EStatementStatuses.PROCESSED_FOR_DELIVERY]: 'Processed for delivery',
  [EStatementStatuses.PRINTED_LOCALLY]: 'Printed Locally',
  [EStatementStatuses.EMAILED]: 'Sent by Email',
  [EStatementStatuses.EMAIL_RETURNED]: 'Email Returned',
  [EStatementStatuses.PENDING]: 'Pending',
  [EStatementStatuses.DO_NOT_BILL_ZERO]: 'Zero Balance',
  [EStatementStatuses.DO_NOT_BILL_NEGATIVE]: 'Negative Balance',
  [EStatementStatuses.DO_NOT_BILL_PERMANENTLY]: 'Permanently Excluded',
  [EStatementStatuses.DO_NOT_BILL_CONTROL]: 'Low Balance',
  [EStatementStatuses.ALREADY_SENT]: 'Already Sent',
  [EStatementStatuses.DO_NOT_BILL_RETURNED]: 'Returned - Do Not Bill',
  [EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED]: 'Email Returned - Do Not Bill',
  'DO_NOT_BILL_LABEL': 'Do Not Bill'
}

export const LETTERS_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [ELetterStatus.NEEDS_REVIEW]: 'Needs Review',
  [ELetterStatus.NEEDS_FIX]: 'Needs Fix',
  [ELetterStatus.READY_TO_MAIL]: 'Ready to Mail',
  [ELetterStatus.SKIP]: 'Excluded',
  [ELetterStatus.IN_PROCESS]: 'In Process',
  [ELetterStatus.IN_TRANSIT]: 'In Transit',
  [ELetterStatus.IN_LOCALAREA]: 'In Local area',
  [ELetterStatus.DELIVERED]: 'Delivered',
  [ELetterStatus.RETURNED]: 'Mail Returned',
  [ELetterStatus.EMAIL_RETURNED]: 'Email Returned',
  [ELetterStatus.REROUTED]: 'Rerouted',
  [ELetterStatus.PROCESSED_FOR_DELIVERY]: 'Processed for delivery',
  [ELetterStatus.PRINTED_LOCALLY]: 'Printed Locally',
  [EStatementStatuses.ALREADY_SENT]: 'Already Sent',
  [ELetterStatus.PENDING]: 'Pending',
  [ELetterStatus.EMAILED]: 'Emailed',
  [ELetterStatus.DO_NOT_BILL]: 'Excluded',
  [ELetterStatus.DO_NOT_BILL_RETURNED]: 'Returned - Do Not Bill',
  [ELetterStatus.DO_NOT_BILL_EMAIL_RETURNED]: 'Email Returned - Do Not Bill'
}

export const PAYMENT_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EPaymentStatus.UPCOMING]: 'Upcoming',
  [EPaymentStatus.APPROVED]: 'Approved',
  [EPaymentStatus.DECLINED]: 'Declined',
  [EPaymentStatus.PENDING]: 'Pending',
  [EPaymentStatus.PENDING_APPROVAL]: 'Pending Approval',
  [EPaymentStatus.PARTIALLY_REFUNDED]: 'Partially Refunded',
  [EPaymentStatus.REFUNDED]: 'Refunded',
  [EPaymentStatus.VOIDED]: 'Voided',
  [EPaymentStatus.CHARGEBACK]: 'Chargeback',
  [EPaymentStatus.SKIPPED]: 'Skipped'
}

export const AUTO_PAYMENT_SETTING_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EAutoPaySettingStatus.COMPLETE]: 'Complete',
  [EAutoPaySettingStatus.DELETED]: 'Deleted',
  [EAutoPaySettingStatus.ACTIVE]: 'Active'
}

export const AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EAutoPayItemStatus.UPCOMING]: 'Upcoming',
  [EAutoPayItemStatus.SCHEDULED]: 'Scheduled',
  [EAutoPayItemStatus.NEEDS_REVIEW]: 'Needs Review',
  [EAutoPayItemStatus.PAID]: 'Processed',
  [EAutoPayItemStatus.DECLINED]: 'Declined',
  [EAutoPayItemStatus.DELETED]: 'Deleted',
  [EAutoPayItemStatus.SKIPPED]: 'Skipped',
  [EAutoPayItemStatus.NO_BALANCE]: 'No balance',
  [EAutoPayItemStatus.DEACTIVATED]: 'Deactivated'
}

export const CHAIN_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EChainStatus.ACTIVE]: 'Active',
  [EChainStatus.NOT_ACTIVE]: 'Inactive'
}

export const USER_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EUserStatus.ACTIVE]: 'Active',
  [EUserStatus.NOT_ACTIVE]: 'Inactive',
  [EUserStatus.WAITING]: 'Waiting'
}

export const BATCH_STATUSES_LABEL_MAP: { [k: string]: string } = {
  [EBatchStatus.COMPLETE]: 'Complete',
  [EBatchStatus.INCOMPLETE]: 'Incomplete',
  [EBatchStatus.RETURNED_MAIL]: 'Returned'
}

export const RESIDENT_STATUS_LABEL_MAP: { [k: string]: string } = {
  [EResidentStatus.ACTIVE]: 'Current',
  [EResidentStatus.INACTIVE]: 'Discharged'
}

export const CLAIM_STATUS_LABEL_MAP: { [k: string]: string } = {
  [EClaimStatus.NO_CLAIM]: 'No Claim',
  [EClaimStatus.ERROR]: 'Error',
  [EClaimStatus.PAID]: 'Paid',
  [EClaimStatus.AWAITING]: 'Awaiting',
  [EClaimStatus.NA]: 'NA',
  [EClaimStatus.PENDING]: 'Pending',
  [EClaimStatus.DENIED]: 'Denied',
  [EClaimStatus.NOT_REGISTERED]: 'Not Registered'
}

export const CLAIM_TASK_STATUS_LABEL_MAP: { [k: string]: string } = {
  [EClaimTaskStatus.INCORRECT]: 'Incorrect',
  [EClaimTaskStatus.COMPLETED]: 'Completed',
  [EClaimTaskStatus.OPENED]: 'Opened'
}

export const LETTERS_MAILED_STATUSES: ELetterStatus[] = [
  ELetterStatus.PRINTED_LOCALLY,
  ELetterStatus.PROCESSED_FOR_DELIVERY,
  ELetterStatus.IN_PROCESS,
  ELetterStatus.IN_LOCALAREA,
  ELetterStatus.IN_TRANSIT,
  ELetterStatus.REROUTED,
  ELetterStatus.DELIVERED,
  ELetterStatus.EMAILED
]

export const LETTERS_UNMAILED_STATUSES: ELetterStatus[] = [
  ELetterStatus.READY_TO_MAIL,
  ELetterStatus.NEEDS_FIX,
  ELetterStatus.NEEDS_REVIEW,
  ELetterStatus.SKIP,
  ELetterStatus.RETURNED,
  ELetterStatus.EMAIL_RETURNED,
  ELetterStatus.DO_NOT_BILL_RETURNED,
  ELetterStatus.DO_NOT_BILL_EMAIL_RETURNED
]

export const LETTERS_MAILABLE_STATUSES: ELetterStatus[] = [
  ELetterStatus.READY_TO_MAIL,
  ELetterStatus.NEEDS_FIX,
  ELetterStatus.NEEDS_REVIEW,
  ELetterStatus.RETURNED,
  ELetterStatus.EMAIL_RETURNED
]

export const STATEMENT_MAILED_STATUSES: EStatementStatuses[] = [
  EStatementStatuses.PRINTED_LOCALLY,
  EStatementStatuses.PROCESSED_FOR_DELIVERY,
  EStatementStatuses.IN_PROCESS,
  EStatementStatuses.IN_LOCALAREA,
  EStatementStatuses.IN_TRANSIT,
  EStatementStatuses.REROUTED,
  EStatementStatuses.DELIVERED,
  EStatementStatuses.EMAILED,
  EStatementStatuses.PENDING
]

export const STATEMENT_UNMAILED_STATUSES: EStatementStatuses[] = [
  EStatementStatuses.READY_TO_MAIL,
  EStatementStatuses.READY_TO_EMAIL,
  EStatementStatuses.READY_TO_PRINT,
  EStatementStatuses.NEEDS_FIX,
  EStatementStatuses.NEEDS_REVIEW,
  EStatementStatuses.DO_NOT_BILL,
  EStatementStatuses.RETURNED,
  EStatementStatuses.EMAIL_RETURNED,
  EStatementStatuses.DO_NOT_BILL_RETURNED,
  EStatementStatuses.DO_NOT_BILL_CONTROL,
  EStatementStatuses.DO_NOT_BILL_ZERO,
  EStatementStatuses.DO_NOT_BILL_NEGATIVE,
  EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
  EStatementStatuses.DO_NOT_BILL_NOW,
  EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED,
  EStatementStatuses.ALREADY_SENT
]

export const PCCUploadTaskStatusMap = {
  [EPccUploadTaskStatus.PENDING]: 'Pending',
  [EPccUploadTaskStatus.IN_PROGRESS]: 'In Progress',
  [EPccUploadTaskStatus.READY]: 'Ready',
  [EPccUploadTaskStatus.FAILED]: 'Failed',
  [EPccUploadTaskStatus.COMPLETED]: 'Completed',
  [EPccUploadTaskStatus.CANCELED]: 'Canceled'
}

let TODAY: Date

export async function getRealDate () {
  await waitUntil(() => TODAY)
  return TODAY
}

fetch('https://worldtimeapi.org/api/timezone/America/New_York.txt').then((res) => res.text()).then((textData: string) => {
  const parts: Array<string[]> = textData.split('\n').map((line: string) => line.split(': '))
  for (let i = 0; i < parts.length; i++) {
    if (parts[i][0] === 'utc_datetime') {
      TODAY = new Date(parts[i][1])
      break
    }
  }
})

export const MONTHS: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const getNumberDayLabel = (num: number) => {
  if (num === 1 || num === 21 || num === 31) {
    return `${num}st`
  } else if (num === 3 || num === 23) {
    return `${num}rd`
  } else if (num === 2 || num === 22) {
    return `${num}nd`
  }
  return `${num}th`
}

export const getNumberWeekDayLabel = (num: number) => {
  const WEEK_DAYS: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
  return WEEK_DAYS[num]
}

export const formatDate = (date: any): string => {
  const momentDate = moment.utc(date)
  if (momentDate.isValid()) {
    return momentDate.format('MM/DD/YYYY')
  }
  return ''
}

export const DO_NOT_BILL_STATUSES: EStatementStatuses[] = [
  EStatementStatuses.DO_NOT_BILL,
  EStatementStatuses.DO_NOT_BILL_NEGATIVE,
  EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
  EStatementStatuses.DO_NOT_BILL_ZERO,
  EStatementStatuses.DO_NOT_BILL_CONTROL,
  EStatementStatuses.DO_NOT_BILL_RETURNED,
  EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED
]
